export default {
  namespaced: true,
  state: {
    id: 0,
    name: "",
    distCountryCode: "WW",
    isDouyinQudao: false,
    fiampStandAlone: 0,
    shoplineHanlder: null,
    shopifyHanlder: null,
    showLuckSellerProducts: false,
    currencyList: null,
  },
  mutations: {
    updateId(state, id) {
      state.id = id;
    },
    updateName(state, name) {
      state.name = name;
    },
    updateDistCountryCode(state, country) {
      state.distCountryCode = country;
    },
    updateIsDouyinQudao(state, isDouyinQudao) {
      state.isDouyinQudao = isDouyinQudao;
    },
    updateFiampStandAlone(state, fiampStandAlone) {
      state.fiampStandAlone = fiampStandAlone;
    },
    updateShoplineHanlder(state, shoplineHanlder) {
      state.shoplineHanlder = shoplineHanlder;
    },
    updateShopifyHanlder(state, shopifyHanlder) {
      state.shopifyHanlder = shopifyHanlder;
    },
    updateCurrencyList(state, currencyList) {
      state.currencyList = currencyList;
    },
    updateShowLuckSellerProducts(state, showLuckSellerProducts) {
      state.showLuckSellerProducts = showLuckSellerProducts;
    },
  },
};
